import {
  cancelSubscription,
  updatePassword,
  updateProfile,
} from "../../../../Redux/Profile/ProfileActions";
import ConfirmationModal from "../../../Common/ConfirmationModal/ConfirmationModal";
import { AppDispatch, RootState } from "../../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import validator from "../../../../Util/validator";
import React, { useEffect, useState } from "react";
import styles from "./MyProfile.module.scss";

function MyProfile() {
  const dispatch = useDispatch<AppDispatch>();
  const { profileData, updateProfileLoading, updatePasswordLoading } =
    useSelector((state: RootState) => state.profile);

  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [nationalIdCard, setNationalIdCard] = useState<string>("");
  const [currentPassword, setCurrentPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmNewPassword, setConfirmNewPassword] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [errors, setErrors] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    nationalIdCard: string;
    phoneNumber: string;
    currentPassword: string;
    newPassword: string;
    confirmNewPassword: string;
  }>({
    firstName: "",
    lastName: "",
    email: "",
    nationalIdCard: "",
    phoneNumber: "",
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const updateProfileHandler = () => {
    if (!updateProfileLoading) {
      const { errors: fieldErrors, isValid } = validator([
        {
          key: "firstName",
          type: "text",
          value: firstName,
        },
        {
          key: "lastName",
          type: "text",
          value: lastName,
        },
        {
          key: "nationalIdCard",
          type: "text",
          value: nationalIdCard,
        },
        {
          key: "phoneNumber",
          type: "text",
          value: phoneNumber,
        },
      ]);
      setErrors({ ...errors, ...fieldErrors });
      if (isValid) {
        dispatch(
          updateProfile({
            firstName: firstName,
            lastName: lastName,
            email: email,
            idNumber: nationalIdCard,
            phonenumber: phoneNumber,
          }),
        );
      }
    }
  };

  const cancelSubscriptionHandler = () => {
    setIsModalOpen(true);
  };

  const confirmSubscriptionCancellationHandler = () => {
    dispatch(cancelSubscription());
  };

  const updatePasswordHandler = () => {
    if (!updatePasswordLoading) {
      const { errors: fieldErrors, isValid } = validator([
        {
          key: "currentPassword",
          type: "text",
          value: currentPassword,
        },
        {
          key: "newPassword",
          type: "text",
          value: newPassword,
        },
        {
          key: "confirmNewPassword",
          type: "text",
          value: confirmNewPassword,
        },
      ]);
      setErrors({ ...errors, ...fieldErrors });
      if (isValid) {
        dispatch(
          updatePassword({
            oldPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmNewPassword,
          }),
        );
      }
    }
  };

  useEffect(() => {
    if (profileData) {
      setFirstName(profileData?.member?.firstName);
      setLastName(profileData?.member?.lastName);
      setEmail(profileData?.member?.email);
      setNationalIdCard(profileData?.member?.nationalId);
      setPhoneNumber(profileData?.member?.phonenumber);
    }
  }, [profileData]);

  return (
    <React.Fragment>
      <ConfirmationModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        text="Are you sure you want to cancel your membership?"
        heading="Cancel Membership"
        onConfirm={confirmSubscriptionCancellationHandler}
        loading={false}
      />
      <div className={styles.mainContainer}>
        <div className={styles.mainContainerBox}>
          <div className={styles.headingContainer}>
            <p className={styles.heading}>Profile Information</p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.input}>
              <p className={styles.label}>Email</p>
              <input
                type="text"
                className={styles.input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                readOnly
              />
            </div>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.input}>
              <p className={styles.label}>First Name</p>
              <input
                type="text"
                className={styles.input}
                value={firstName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z'-]*$/.test(value)) {
                    setFirstName(value);
                  }
                }}
              />
              <p className={styles.error}>{errors.firstName}</p>
            </div>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.input}>
              <p className={styles.label}>Last Name</p>
              <input
                type="text"
                className={styles.input}
                value={lastName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z'-]*$/.test(value)) {
                    setLastName(value);
                  }
                }}
              />
              <p className={styles.error}>{errors.lastName}</p>
            </div>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.input}>
              <p className={styles.label}>Phone Number</p>
              <input
                type="text"
                className={styles.input}
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
              <p className={styles.error}>{errors.phoneNumber}</p>
            </div>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.input}>
              <p className={styles.label}>National ID Card</p>
              <input
                type="text"
                className={styles.input}
                value={nationalIdCard}
                onChange={(e) => setNationalIdCard(e.target.value)}
                readOnly
              />
              <p className={styles.error}>{errors.nationalIdCard}</p>
            </div>
          </div>
          {updateProfileLoading && <Loading />}
          <div className={styles.buttonContainer}>
            <button className={styles.button} onClick={updateProfileHandler}>
              Update
            </button>
          </div>
        </div>
        <div className={styles.mainContainerBox}>
          <div className={styles.headingContainer}>
            <p className={styles.heading}>Update Password</p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.input}>
              <p className={styles.label}>Current Password</p>
              <input
                type="text"
                className={styles.input}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
              <p className={styles.error}>{errors.currentPassword}</p>
            </div>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.input}>
              <p className={styles.label}>New Password</p>
              <input
                type="text"
                className={styles.input}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <p className={styles.error}>{errors.newPassword}</p>
            </div>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.input}>
              <p className={styles.label}>Confirm New Password</p>
              <input
                type="text"
                className={styles.input}
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
              />
              <p className={styles.error}>{errors.confirmNewPassword}</p>
            </div>
          </div>
          {updatePasswordLoading && <Loading />}
          <div className={styles.buttonContainer}>
            <button className={styles.button} onClick={updatePasswordHandler}>
              Update
            </button>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <button
            className={styles.cancelButton}
            onClick={cancelSubscriptionHandler}
          >
            Cancel Membership
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

export default MyProfile;
